import React from "react";

import { Media, Container, Row, Col } from "reactstrap";
import OpenFileLink from "../Components/OpenFileLink";
import { joinCss } from "../helpers/utils";
import LinesEllipsis from "react-lines-ellipsis";

import appClasses from "../App.module.scss";
import classes from "./lastUpdate.module.scss";

import fixLogo from "../images/fixBig.png";
import editionLogo from "../images/editionBig.png";

const lastUpdate = props => {
  let logo = fixLogo;
  let altText = "דף תיקון";
  if (props.data.docParentID == "") {
    logo = editionLogo;
    altText = "מהדורה";
  }
  return (
    <Container
      key={props.data.id}
      className={joinCss(
        props.componentClass,
        classes.cube,
        appClasses["center-div"]
      )}
    >
      <Row>
        <Col>
          <Media
            object
            className={classes.lastUpdateCubeLogo}
            src={logo}
            alt={altText}
          />
        </Col>
      </Row>
      <Row>
        <Col className={classes.lastUpdateName}>
          <LinesEllipsis maxLine="2" text={props.data.name} />
        </Col>
      </Row>
      <Row>
        <Col sm="12">
          <OpenFileLink
            localClass={appClasses["center-div"]}
            contant={props.data.pdfName}
            id={props.data.id}
          />
        </Col>
      </Row>
    </Container>
  );
};

export default lastUpdate;
